export default __webpack_public_path__ + "static/media/instagram.b66183bd.webp";